import g3 from "../../assets/images/gallery/f13.jpg";
import g4 from "../../assets/images/gallery/f14.jpg";
import g5 from "../../assets/images/gallery/f5.jpg";
import p1 from "../../assets/images/portfolio/p1.jpg";
import p2 from "../../assets/images/portfolio/p2.jpg";
import v1 from "../../assets/images/portfolio/v1.mp4";
import v2 from "../../assets/images/portfolio/v2.mp4";
import v3 from "../../assets/images/portfolio/v3.mp4";
import v4 from "../../assets/images/portfolio/v4.mp4";
import v6 from "../../assets/images/portfolio/v6.mp4";
import tiktok from "../../assets/images/icons/tiktok-rounded-square-icon.svg";
import youtube from "../../assets/images/icons/youtube-color-icon.svg";

const PortfolioBody = () => {
  return (
    <section className="pageGallery section-spacing-80 no-padding-top">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="page-body-content-container section-spacing-30 minus-margin-top-50 relative">
              <div className="gallery-container">
                <ul className="gallery">
                  <li className="gallery-item">
                    <figure>
                      <img src={p1} alt="Flexi Painters Portfolio" />
                      <figcaption>Flexi Painters</figcaption>
                    </figure>
                  </li>
                  <li className="gallery-item">
                    <figure>
                      <img src={p2} alt="Flexi Painters Portfolio" />
                      <figcaption>Flexi Painters</figcaption>
                    </figure>
                  </li>
                  <li className="gallery-item tall">
                    <figure>
                      <img src={g5} alt="Flexi Painters Portfolio" />
                      <figcaption>Flexi Painters</figcaption>
                    </figure>
                  </li>
                  <li className="gallery-item">
                    <figure>
                      <img src={g4} alt="Flexi Painters Portfolio" />
                      <figcaption>Flexi Painters</figcaption>
                    </figure>
                  </li>
                  <li className="gallery-item">
                    <figure>
                      <img src={g3} alt="Flexi Painters Portfolio" />
                      <figcaption>Flexi Painters</figcaption>
                    </figure>
                  </li>
                </ul>
                <ul className="gallery video-gallery">
                  <li className="gallery-item">
                    <video src={v1} mute controls></video>
                  </li>
                  <li className="gallery-item">
                    <video src={v2} mute controls></video>
                  </li>
                  <li className="gallery-item tall">
                    <video src={v6} mute controls></video>
                  </li>
                  <li className="gallery-item">
                    <video src={v3} mute controls></video>
                  </li>
                  <li className="gallery-item">
                    <video src={v4} mute controls></video>
                  </li>
                </ul>
              </div>
            </div>
            <div className="page-footer center section-spacing-40">
              <h3 className=" flexi-skyblue border-blue-bottom">
                View More on Our Tiktok & Youtube
              </h3>
              <div className="footer-cta-container">
                <a
                  href="https://tiktok.com/flexipainters"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Flexi Painters on Tiktok"
                >
                  <img src={tiktok} alt="Flexi Painters on Tiktok" />
                  <p>Flexi Painters</p>
                </a>
                <a
                  href="https://youtube.com/flexipainters"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Flexi Painters on Youtube"
                >
                  <img src={youtube} alt="Flexi Painters on Youtube" />
                  <p>Flexi Painters</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioBody;
